export default {"src":"/bnb/_next/static/media/bnb-light.88a9463c.svg","height":26,"width":26};